module.exports = __webpack_public_path__ + "static/media/relocation.5818ccec.svg";